import { MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createStructuredSelector } from "reselect";
import Loader from "../../Components/Loader";
import { selectIsLoading } from "../../Containers/App/selector";
import { setAccountConfirmation } from "./action";

import style from "./style.module.scss";

function Confirmation({ isLoading }) {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isFailed, setIsFailed] = useState(false);
	const cbSuccess = () => {
		toast.success("Your account is successfully confirmed!");
		setTimeout(() => {
			navigate("/login");
		}, 3000);
	};
	const cbFailed = () => {
		setIsFailed(true);
		toast.error("We're sorry there's something wrong");
	};
	useEffect(() => {
		const confirmationCode = location?.pathname?.split("/")[2];
		if (confirmationCode) {
			dispatch(setAccountConfirmation(confirmationCode, cbSuccess, cbFailed));
		}
	}, []);
	const getIcon = () => {
		if (isFailed) {
			return <MDBIcon fas icon='times' size='4x' className={style.icon} />;
		}
		return <MDBIcon fas icon='check' size='4x' className={style.icon} />;
	};
	const getStyle = () => {
		if (isFailed) {
			return style.iconFailed;
		}
		return style.iconSuccess;
	};
	if (isLoading) {
		return <Loader />;
	}

	return (
		<div className={style.container}>
			<div className={style.contentContainer}>
				<div className={style.iconContainer}>
					<div className={getStyle()}>{getIcon()}</div>
				</div>
				<h3 className={style.iconText}>
					{isFailed
						? "Account failed to confirm!"
						: "Account successfully confirmed"}
				</h3>
				<p className={style.descText}>
					{isFailed
						? "Link is invalid or there is something wrong."
						: "Please wait, You will be redirected.."}
				</p>
			</div>
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	isLoading: selectIsLoading,
});

export default connect(mapStateToProps)(Confirmation);
